export default __webpack_public_path__ + "src/images/packages/maison-de-plage/deb678f481ed11b1df58a18b785532ab-3.jpg";